import { defineMessages } from 'react-intl';

export const pwtSharedMessages = defineMessages({
  emptyHash: {
    id: 'phc-web-toolkit.common.intlLabels.emptyHash',
    defaultMessage: '—',
  },
  viewDetails: {
    id: 'phc-web-toolkit.common.intlLabels.viewDetails',
    defaultMessage: 'View Details',
  },
  settings: {
    id: 'phc-web-toolkit.common.intlLabels.settings',
    defaultMessage: 'Settings',
  },
});
